import CustomSegment from '@/components/CustomSegment';
import PageTitle from '@/components/PageTitle';
import { useSegment } from '@/hooks/useSegment';
import DashboardLayout from '@/layouts/DashboardLayout';
import type { SegmentedType } from '@/types/global.types';
import Filters from './_components/Filters';
import OwnAppraisal from './_components/OwnAppraisal';
import TeamAppraisal from './_components/TeamAppraisal';

export type LineManagerAppraisalSegmentType =
  | 'own-appraisal'
  | 'team-appraisal';

const LineManagerAppraisal = () => {
  const { segment, setSegment } = useSegment<LineManagerAppraisalSegmentType>(
    'line-manager-appraisal',
    'own-appraisal',
    false,
  );

  const SEGMENT_CONFIG: SegmentedType<LineManagerAppraisalSegmentType>[] = [
    {
      value: 'own-appraisal',
      label: 'Own Appraisal',
      view: <OwnAppraisal />,
    },
    {
      value: 'team-appraisal',
      label: 'Team Members Appraisal',
      view: <TeamAppraisal />,
    },
  ];

  const currentSegment = SEGMENT_CONFIG.find((s) => s.value === segment);

  return (
    <DashboardLayout title="Performance">
      <PageTitle
        classNames={{ root: 'items-start' }}
        title="Performance"
        items={[
          { title: 'Dashboard', path: '/admin/control-panel/dashboard' },
          { title: currentSegment?.label },
        ]}
      >
        <Filters type={segment} />
      </PageTitle>

      <CustomSegment
        config={SEGMENT_CONFIG}
        selected={segment}
        onChange={setSegment}
      />
      <div className="mt-5">{currentSegment?.view}</div>
    </DashboardLayout>
  );
};

export default LineManagerAppraisal;
